import { Injectable } from '@nestjs/common';
import { SoInspectionDto } from 'libs/shared-models/sale-management/src/lib/sale-order/dto/so-inspection.dto';
import { SaleInspectionDetails } from '../so-inspections.entity';
import { UpdateSoInspectionInfo } from './so-inspection-update.dto';
import { SoInspectionDTO } from './so-inspection.dto';

@Injectable()
export class SoInspectionAdapter {
  
  public convertDtoToEntity(soInspectionDTO: UpdateSoInspectionInfo,  isUpdate: boolean = false ): SaleInspectionDetails {
    const soInspection = new SaleInspectionDetails();
    soInspection.SoInspectionId=soInspectionDTO.soInspectionId;
    soInspection.inspectionName=soInspectionDTO.inspectionName;
    soInspection.isChecked=soInspectionDTO.isChecked;

    // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    // soInspection.isActive=soInspectionDTO.isActive==undefined?true:soInspectionDTO.isActive;
    // if (isUpdate) {
    //     soInspection.updatedUser = soInspectionDTO.updatedUser;
    // } else {
    //     soInspection.isActive = true;
    //     soInspection.createdUser = soInspectionDTO.createdUser;
    // }
   return soInspection;
  }
  public convertEntityToDto(soInspectionObject: any): SoInspectionDTO {
    const soInspectionDTO= new SoInspectionDTO;
    soInspectionDTO.soInspectionId=soInspectionObject.SoInspectionId;
    soInspectionDTO.inspectionName=soInspectionObject.inspectionName;
    soInspectionDTO.isChecked=soInspectionObject.isChecked;
    soInspectionDTO.saleOrderInfo=soInspectionObject.saleOrderInfo;
    soInspectionDTO.saleOrderId=soInspectionObject.saleOrderId;
    soInspectionDTO.saleOrderNumber=soInspectionObject.saleOrderNumber;
    soInspectionDTO.isActive = soInspectionObject.isActive;
    soInspectionDTO.createdAt = soInspectionObject.createdAt;
    soInspectionDTO.updatedAt = soInspectionObject.updatedAt;
    soInspectionDTO.createdUser = soInspectionObject.createdUser;
    soInspectionDTO.updatedUser = soInspectionObject.updatedUser;
    soInspectionDTO.versionFlag = soInspectionObject.versionFlag;
    return soInspectionDTO;
  }
}
